export default __webpack_public_path__ + "media/images/logo_dark-d7cf99191e6cbf49894628996a119051.png";